import Loadable from 'UIComponents/decorators/Loadable';
const AsyncMarketingHomePopup = Loadable({
  loader: () => import( /* webpackChunkName: "marketing-home-popup" */'email-management-lib/refactor/components/manage/experiments/MarketingHomePopup'),
  LoadingComponent: () => null
});
export default AsyncMarketingHomePopup;